var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKokpit = function SvgKokpit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.74,
    height: 19.72,
    viewBox: "0 0 19.74 19.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_1_kokpit"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.74,
    height: 19.72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1_kokpit",
    "data-name": "1 kokpit",
    clipPath: "url(#clip-_1_kokpit)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M9.87,19.719A9.859,9.859,0,1,0,0,9.859,9.886,9.886,0,0,0,9.87,19.719ZM4.208,16.47a7.6,7.6,0,0,1,11.324,0,8.7,8.7,0,0,1-11.324,0ZM3.5,9.282a6.361,6.361,0,0,1,1.46-3.514l.786.785.818-.817-.786-.785A6.375,6.375,0,0,1,9.291,3.493V4.622h1.157V3.493a6.375,6.375,0,0,1,3.517,1.458l-.786.785L14,6.553l.786-.785a6.362,6.362,0,0,1,1.46,3.514h-1.13v1.155h1.13a6.433,6.433,0,0,1-1.636,3.739,8.77,8.77,0,0,0-9.474,0A6.432,6.432,0,0,1,3.5,10.437h1.13V9.282ZM9.87,1.155a8.7,8.7,0,0,1,6.489,14.505,8.654,8.654,0,0,0-.82-.794,7.556,7.556,0,1,0-11.339,0,8.653,8.653,0,0,0-.82.794A8.7,8.7,0,0,1,9.87,1.155Zm0,0",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M211,392h3.47v1.157H211Zm0,0",
    transform: "translate(-202.865 -376.903)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M167.781,170.169a1.735,1.735,0,1,0,2.384-2.384l-.03-.018-4.35-1.978,1.978,4.35Zm1.807-1.381a.578.578,0,1,1-.8.8l-.67-1.473Zm0,0",
    transform: "translate(-159.395 -159.406)",
    fill: "#a8b0b6"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKokpit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kokpit.11697c80.svg";
export { ForwardRef as ReactComponent };